import { Breadcrumb } from "../../../../core/Breadcrumb.js";
import type { BoxesBreadcrumbContent } from "../../boxesContent.js";

/** Where the catalog sits: the pages above it, linked, then this one. */
export function BoxesBreadcrumb({ trail, current }: BoxesBreadcrumbContent) {
  return (
    <Breadcrumb
      items={[...trail.map(({ href, label }) => ({ href, label })), { label: current }]}
    />
  );
}
